import { IProductInfo } from "../types/Menu";

// Ровно та часть меню, по которой ищем: и ответ бэка (IMenuList), и результат
// menuListAdapter подходят под неё, а лишние поля адаптера тут не нужны.
type MenuCategory = {
  id: number;
  menu: IProductInfo[];
};

/**
 * Меню филиала — единственный источник правды о том, доступно ли блюдо: бэк
 * отдаёт в нём только то, что этот филиал реально готовит. Значит, удалённое,
 * снятое с продажи и просто несуществующее блюдо выглядят одинаково — его в
 * меню нет.
 */
export const findProductInMenu = <T extends MenuCategory>(
  menu: T[],
  productId: number,
) =>
  menu
    .flatMap((category) => category.menu)
    .find((product) => product.id === productId);

export const findCategoryInMenu = <T extends MenuCategory>(
  menu: T[],
  categoryId: number,
) => menu.find((category) => category.id === categoryId);
